define(['../models/QuickQuoteTile', 'text!./templates/pa-quick-quote-quoted-state.html'], (quickQuoteTile, template) =>[() => ({
    'restrict': 'A',
    template,
    'scope': {
        'model': '='
    },
    controller: ['$scope', 'quickquote.QuickQuoteService', 'InsuranceSuiteMetadata', 'qnb.EmailService', 'ModalService', '$q', '$translate',
                 ($scope, QuickQuoteService, InsuranceSuiteMetadata, QuoteEmailService, ModalService, $q, $translate) => {
        $scope.totalPremiumString = 'quoteandbind.pa.directives.templates.pa-quick-indicative.total premium';

        if (angular.isDefined($scope.model)) {
            const termTypeList = InsuranceSuiteMetadata.get('pc').types.getTypelist('TermType');

            if ($scope.model.quote.termType === termTypeList.getCode('Annual').code) {
                $scope.totalPremiumString = 'quoteandbind.pa.directives.templates.pa-quick-indicative.per 12 months';
            } else if ($scope.model.quote.termType === termTypeList.getCode('HalfYear').code) {
                $scope.totalPremiumString = 'quoteandbind.pa.directives.templates.pa-quick-indicative.per 6 months';
            }
        }

        $scope.emailQuote = ()=> {
            const emailAddress = $scope.model.contactEmail;
            const emailInfo = {
                quoteID: $scope.model.quote.reference,
                sessionID: $scope.model.quote.sessionUUID
            };

            $q.when(QuoteEmailService.emailQuote('quoteandbind', emailInfo), ()=> {
                ModalService.showInfo(
                    'quoteandbind.directives.QnbWizardButtons.Quote Emailed',
                    $translate('quoteandbind.directives.QnbWizardButtons.The quote details have been emailed', {emailAddress: emailAddress}));
            }, ()=> {
                ModalService.showError(
                    'quoteandbind.directives.QnbWizardButtons.Error',
                    'quoteandbind.directives.QnbWizardButtons.Sorry, we were not able to email the quote details at this time.');
            });
        };
    }]
})]);


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/quickquote/pa/tiles/quote/directives/PAQuickQuoteQuotedState.js
 **/